import * as browserHelper from './browserHelper';
import * as helpers from '../common/helpers';

const reportWarning = (msg, extras = {}) => typeof helpers.lWindow === 'object' && browserHelper.hasRaven(helpers.lWindow) && helpers.lWindow.Raven.captureMessage(msg, Object.assign({}, extras, {
  level: 'warning'
}));

export default reportWarning;